import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import ProtectedRoute from "../components/ProtectedRoute";
import SkillTree3DView from "../components/SkillTree3DView";
import { apiService } from "../services/api";
import type { Course } from "../services/api";
import "../css/SkillTree.css";

function SkillTreeConcept() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadCourses = async () => {
      try {
        setLoading(true);
        const coursesData = await apiService.getCoursesAsRecord();
        const coursesArray = Object.values(coursesData);
        setCourses(coursesArray);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load courses');
      } finally {
        setLoading(false);
      }
    };

    loadCourses();
  }, []);

  if (loading) {
    return (
      <div className="skill-tree-container">
        <div className="skill-tree-header">
          <h1>🌳 Skill Tree Concept [DEV MODE]</h1>
          <p>Loading courses...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="skill-tree-container">
        <div className="skill-tree-header">
          <h1>🌳 Skill Tree Concept [DEV MODE]</h1>
          <p style={{ color: '#ef4444' }}>Error: {error}</p>
        </div>
      </div>
    );
  }

  const totalLabs = courses.reduce((sum, course) => sum + (course.labs?.length || 0), 0);

  return (
    <div className="skill-tree-container">
      <div className="skill-tree-header">
        <h1>🌳 3D Skill Tree [DEV MODE]</h1>
        <p>Interactive hierarchical visualization of your learning path</p>
        <p style={{ fontSize: '0.9rem', color: '#94a3b8', marginTop: '0.5rem' }}>
          {courses.length} courses • {totalLabs} labs • Real data from your API
        </p>
      </div>

      <div className="skill-tree-content">
        <SkillTree3DView courses={courses} />
      </div>
    </div>
  );
}

function SkillTreeConceptRoute() {
  return (
    <ProtectedRoute>
      <SkillTreeConcept />
    </ProtectedRoute>
  );
}

export const Route = createFileRoute("/skill-tree-concept")({
  component: SkillTreeConceptRoute,
});
